import apiNews from '@/api/news'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null,
  lastPage: null,
}

export const mutationTypes = {
  getNewsStart: '[news] Get news start',
  getNewsSuccess: '[news] Get news success',
  getNewsFailure: '[news] Get news failure',
}

export const actionTypes = {
  getNews: '[news] Get news',
}

const mutations = {
  [mutationTypes.getNewsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getNewsSuccess](state, payload) {
    state.data = payload.data
    state.total = payload.total | 0
    state.lastPage = payload.last_page | 0
    state.isLoading = false
  },

  [mutationTypes.getNewsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getNews](context, params) {
    context.commit(mutationTypes.getNewsStart)
    return new Promise((resolve) => {
      apiNews
        .getNewsAll(params)
        .then((response) => {
          context.commit(mutationTypes.getNewsSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getNewsFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
